@if (offersData && offersData.length) {
    <div id="offers-widget" data-crlat="widgetOffers">
        @for (offer of offersData; let i = $index; track trackByOffersData(i, offer)) {
            <accordion [accordionTitle]="offer.name" [isExpanded]="true" data-crlat="offerAccordion">
                <accordion-body>
                    <div
                        ngCarousel
                        [ngCarouselName]="'offers-carousel-' + i"
                        class="offers-carousel"
                        [ngCarouselTimer]="DURATION"
                        [ngCarouselWatch]="offer.offers"
                        [ngCarouselLoop]="true"
                        (isCarouselInit)="onCarouselInit($event, i)">
                        <slidecontainer
                            class="carousel-slides"
                            [ngClass]="{ 'carousel-no-scroll': offer.offers.length === 1 }"
                            (click)="sendGTM(offer, i)"
                            data-crlat="slidecontainer">
                            @for (slide of offer.offers; track trackByOffers($index, slide)) {
                                <slide class="slide" data-crlat="offerSlide">
                                    <a
                                        (click)="redirect(slide.targetUri)"
                                        [ngClass]="{ 'img-not-found': !slide.image }"
                                        class="slide-link"
                                        [attr.target]="slide.relUri ? '_blank' : ''"
                                        click-link
                                        linkHref
                                        [link]="slide.targetUri"
                                        data-crlat="offerLink">
                                        <!-- ng-error migrated to (error) -->
                                        @if (slide.image) {
                                            <img
                                                [attr.src]="slide.image"
                                                [attr.alt]="slide.targetUri"
                                                disable-dragging
                                                (error)="slide.image = ''"
                                                data-crlat="offerImage"
                                                width="290"
                                                height="180" />
                                        } @else {
                                            <span data-crlat="noImage">Image Not Found</span>
                                        }
                                    </a>
                                </slide>
                            }
                        </slidecontainer>
                        @if (offer.offers.length > 1 && isCarouselInited[i]) {
                            <ul class="slide-dots" data-crlat="slideDots">
                                @for (slide of offer.offers; let j = $index; track trackBySlide(j, slide)) {
                                    <li [ngClass]="{ 'slide-active': setActiveSlide(j, i) }" data-crlat="slideDotContainer">
                                        <button type="button" (click)="gotToSlide(j, i)" data-crlat="dotBtn"></button>
                                    </li>
                                }
                            </ul>
                        }
                    </div>
                </accordion-body>
            </accordion>
        }
    </div>
}
